import React from 'react';
import Input from '../../Input';
import { maskSocialMedia } from '../../../Utils/masks';
const FacebookInput = ({ value, isEditable, setValue, userData }) => {
  return (
    <Input
      labelName={'Facebook'}
      value={value ?? ''}
      disabled={!isEditable}
      placeholder={'Digite o @ do Facebook'}
      marginTop={0}
      maxLength={51}
      handleInputChange={(e) =>
        setValue({
          ...userData,
          Facebook: maskSocialMedia(e.currentTarget.value),
        })
      }
    />
  );
};

export default FacebookInput;
